import './style.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import Routes from './core/routing/';
// import registerServiceWorker from './registerServiceWorker';
import store, { persistor } from './core/store';
import { BrowserRouter } from 'react-router-dom';

import './core/i18n';

const Root = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById('root'));

// TODO: Configure some day.
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js